import React from 'react'
import Box from '@material-ui/core/Box'
import { PGA_COM_HOST } from 'env'
import CoachCard from './coach-card'
import SessionSectionHeader from '../sessions/session-section-header'
import { useStyles } from './styles'

const COACH_SEARCH_URL = `${PGA_COM_HOST}/coaches/search`

const YourCoaches = ({ coaches }) => {
  const classes = useStyles()

  if (!coaches.length) {
    return null
  }

  return (
    <Box className={classes.section}>
      <SessionSectionHeader
        title="Your coaches"
        linkLabel="Browse coaches"
        onLinkClick={() => {
          window.location.href = COACH_SEARCH_URL
        }}
      />
      <Box
        className={`${classes.coachGrid} ${
          coaches.length === 1 ? classes.coachGridSingle : ''
        }`}
      >
        {coaches.map(coach => (
          <CoachCard key={coach.id} coach={coach} />
        ))}
      </Box>
    </Box>
  )
}

export default YourCoaches
